// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6156d38a","455":"daf7dac1","879":"23d33f05"}[chunkId] + ".chunk.js";
};